<nav #navbarRef>
  <div class="myre-container">
    <myre-layout-row-container class="myre-header" [phoneGutters]="true">
      <myre-layout-column
        class="myre-header_left"
        [d]="layout.d.left"
        [t]="layout.t.left"
        [p]="layout.p.left"
      >
        <ng-content select="[left]" />
      </myre-layout-column>

      <myre-layout-column
        class="myre-header_center"
        [d]="layout.d.center"
        [t]="layout.t.center"
        [p]="layout.p.center"
      >
        <ng-content select="[center]" />
      </myre-layout-column>

      <myre-layout-column
        class="myre-header_right"
        [d]="layout.d.right"
        [t]="layout.t.right"
        [p]="layout.p.right"
      >
        <ng-content select="[right]" />
      </myre-layout-column>
    </myre-layout-row-container>
  </div>
</nav>

<div [myreMatchHeight]="navbarRef"></div>
